import type { PaginatedResponse } from "@/types/common.types";

// 兑换码批次
export interface Code {
  id: string; // 主键

  CardDuration: number; // 会员时长
  CardSpecID: number; // 会员规格ID
  CardTypeDesc: string; // 正式会员、体验会员
  CardTypeID: cardTypeIDType; // 正式卡、体验卡
  CardUnit: string; // 会员单位
  Gift: string; // 无、1个月-12个月
  GiftID: number;

  Name: string; // 兑换码名称
  Partner: {
    Name: string;
  }; // 合作伙伴
  PartnerID: number; // 合作伙伴ID
  PartnerName: string; // 合作伙伴名称
  PlatformID: platformIDType; // 平台ID，抖音、微信

  TotalQuantity: number; // 总数量
  ActivatedCount: number; // 激活数量
  UsedCount: number; // 已使用数量
  InactiveCount: number; // 未激活数量
  RefundCount: number; // 退款数量
  ExpiredCount: number; // 过期数量
  InvalidatedCount: number; // 失效数量

  created_at: string; // 本批次兑换码创建时间
  created_by: string; // 创建者
  updated_at: string; // 更新时间
  updated_by: string; // 更新者
  StartTime: string; // 生效开始时间
  EndTime: string; // 生效结束时间
  InvalidReason: string; // 失效理由
  Status: "active" | "invalidated" | "expired"; // 状态

  Remark: string; // 备注

  // platform: string; // 平台
  // partner: string; // 合作伙伴
  // code_name: string; // 兑换码名称
  // card_type: string; // 卡类型
  // card_unit: string; // 卡规格
  // gift: string; // 赠品
  // code_num: number; // 兑换码数量
  // exchange_start_time: string; // 可兑换开始时间
  // exchange_end_time: string; // 可兑换结束时间
  // activated_num: number; // 已激活数量
  // exchange_num: number; // 已核销数量
  // nonactivated_num: number; // 未激活数量
  // refund_num: number; // 退款数量
  // overdue_num: number; // 已过期数量
  // disabled_num: number; // 已设置失效数量
  // created_at: string; // 生成时间
  // description: string; // 备注
  // disabled_reason: string; // 失效理由
}
export interface Partner {
  id: string;
  name: string;
  isDel: number; // 是否删除
  platformID: number; // 平台ID
  userID: number; // 用户ID
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
  Name: string;
}

export interface CodeDetailType {
  id: string;
  BatchNo: string; // 批次
  ExchangeCodeID: string; // 兑换码id
  Code: string; // 兑换码名称
  BindPhone: string; // 手机号
  BindTime: string;
  ExchangeStatus: string; // 兑换码状态
  VipStatus: string; // vip状态
  VerifyStatus: string; // 核销状态
  VerifyTime: string; // 核销时间
  ActiveTime: string; // 激活时间
  RefundTime: string; // 退款时间
  Remark: string; // 备注
  ExchangeCode: Code; // 兑换码批次信息
  created_at: string; // 创建时间
  created_by: string; // 创建者
  updated_at: string; // 更新时间
  updated_by: string; // 更新者
}

export type CodesResponse = PaginatedResponse<Code>;

export type GetCodesParams = {
  page: number;
  page_size: number;
  card_type?: number; //卡类型
  end_time?: string; // 生效结束时间
  partner_id?: number; // 合作伙伴ID
  platform_id?: number; // 平台ID
  start_time?: string; // 生效开始时间
  name?: string; // 兑换码名称
  time_field?: string; // 时间
  card_spec?: string; // 卡规格
  gift?: "0" | "1" | "-1";
};
export type CreateCodesParams = {
  card_spec_id: number;
  card_type_id: number;
  end_time: string;
  gift_id: string;
  name: string;
  partner_id: number;
  platform_id: number;
  remark: string;
  start_time: string;
  total_quantity: number;
};
export type PartnerParams = {
  page: number;
  page_size: number;
  name?: string;
  platform_id?: number;
};
export type GetCodeDetailListParams = {
  page: number;
  page_size: number;

  code_id?: number; // 兑换码批次ID
  code?: string; // 兑换码
  name?: string; // 兑换码名称
  exchange_status?: string; // 兑换状态

  partner_id?: number; // 合作伙伴ID
  platform_id?: number; // 平台ID
  phone?: string; // 手机号

  time_field?: string; // 时间
  end_time?: string; // 生效结束时间
  start_time?: string; // 生效开始时间

  card_type?: number; //卡类型
  card_spec?: string; // 卡规格
  // gift?: "0" | "1" | "-1";
  vip_status?: string; // VIP状态
};

export type platformIDType = 1 | 2;
export const PLATFORM_OPTIONS = {
  1: "抖音",
  2: "微信",
};

export type cardTypeIDType = 1 | 2;
export const CARD_TYPE_ID_OPTIONS = {
  1: "体验卡",
  2: "正式卡",
};

export type AddPartnerParams = {
  name: string;
  platform_id: string;
  remark?: string;
};

export const TIME_OPTIONS = [
  { key: "created_at", value: "生成时间" },
  { key: "start_time", value: "生效时间" },
  { key: "end_time", value: "失效时间" },
];

export const STATUS_OPTIONS = [
  { key: "active", value: "激活" },
  { key: "inactive", value: "未激活" },
  { key: "refunded", value: "已退款" },
  { key: "expired", value: "已过期" },
  { key: "invalid", value: "已设置失效" },
];

export const TASTE_DURATION_OPTIONS = [
  { key: "7", value: "7天" },
  { key: "14", value: "14天" },
  { key: "31", value: "1个月" },
  { key: "93", value: "3个月" },
];

export const FULL_DURATION_OPTIONS = [
  { key: "365", value: "1年VIP" },
  { key: "730", value: "2年VIP" },
];

export const VIP_STATUS_OPTIONS = [
  { value: "active", key: "生效中" },
  // {key:"",value:"已退款"},
  // {key:"",value:"已过期"},
  // {key:"",value:"已设置失效"},
  { value: "inactive", key: "未激活" },
  // {key:"",value:"已过期"},
  // {key:"",value:"已设置失效"},
];
